// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file authenticator_type.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file authenticator_type.proto.
 */
export const file_authenticator_type: GenFile = /*@__PURE__*/
  fileDesc("ChhhdXRoZW50aWNhdG9yX3R5cGUucHJvdG8SBmRvbWFpbiqvAgoRQXV0aGVudGljYXRvclR5cGUSHgoaQVVUSEVOVElDQVRPUl9UWVBFX1VOS05PV04QABIbChdBVVRIRU5USUNBVE9SX1RZUEVfUFVTSBABEiIKHkFVVEhFTlRJQ0FUT1JfVFlQRV9CQUNLVVBfQ09ERRACEiAKHEFVVEhFTlRJQ0FUT1JfVFlQRV9CQUNLVVBfT1MQAxIcChhBVVRIRU5USUNBVE9SX1RZUEVfRFVNTVkQBBIlCiFBVVRIRU5USUNBVE9SX1RZUEVfU0VTU0lPTl9VTkxPQ0sQBhIfChtBVVRIRU5USUNBVE9SX1RZUEVfV0VCQVVUSE4QBxIrCidBVVRIRU5USUNBVE9SX1RZUEVfT1JHQU5JWkFUSU9OX1NFUlZJQ0UQCCIECAUQBUJSChphcHAuaGV5bG9naW4uYW5kcm9pZC5wcm90b1ouZ2l0bGFiLmNvbS9jb3RlY2hkZS9tb25vcmVwby9iYWNrZW5kL2RvbWFpbi9wYqICA0hQQWIGcHJvdG8z");

/**
 * @generated from enum domain.AuthenticatorType
 */
export enum AuthenticatorType {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: AUTHENTICATOR_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: AUTHENTICATOR_TYPE_PUSH = 1;
   */
  PUSH = 1,

  /**
   * @generated from enum value: AUTHENTICATOR_TYPE_BACKUP_CODE = 2;
   */
  BACKUP_CODE = 2,

  /**
   * @generated from enum value: AUTHENTICATOR_TYPE_BACKUP_OS = 3;
   */
  BACKUP_OS = 3,

  /**
   * @generated from enum value: AUTHENTICATOR_TYPE_DUMMY = 4;
   */
  DUMMY = 4,

  /**
   * @generated from enum value: AUTHENTICATOR_TYPE_SESSION_UNLOCK = 6;
   */
  SESSION_UNLOCK = 6,

  /**
   * @generated from enum value: AUTHENTICATOR_TYPE_WEBAUTHN = 7;
   */
  WEBAUTHN = 7,

  /**
   * @generated from enum value: AUTHENTICATOR_TYPE_ORGANIZATION_SERVICE = 8;
   */
  ORGANIZATION_SERVICE = 8,
}

/**
 * Describes the enum domain.AuthenticatorType.
 */
export const AuthenticatorTypeSchema: GenEnum<AuthenticatorType> = /*@__PURE__*/
  enumDesc(file_authenticator_type, 0);

